import { useState, useEffect } from "react";
import { VotacionElementCompleto } from "../../components/cards";
import { getCongresistasPublic, getLogDelegatesSeatNumberActiveConferencePublic, getGruposBancadaPublic, getVotosVotacionActivaPublic, getSeatCoordinateCompletePublic } from "../../services/juntanominadora";
import * as React from "react";
import stylesVotaciones from "../../styles/votacionStyles.module.css"

const DiagramaCompletoImpresion: React.FC = () => {
    const [congresistas, setCongresistas] = useState<any[]>([]);
    const [gruposBancada, setGruposBancada] = useState<any[]>([]);
    const [logDelegatesSeatNumber, setLogDelegatesSeatNumber] = useState<any[]>([]);
    const [SVDelegatesVotaron, setSVDelegatesVotaron] = useState<any[]>([]);
    //const [seatNumbers, setSeatNumbers] = useState<any[]>([]);
    const [coordenadas, setCoordenadas] = useState<any[]>([]);
    const [congresistasConectados, setcongresistasConectados] = useState<number>(0);

    useEffect(() => {
        const inv = setInterval(() => {
            // Obtener todos los congresistas
            if(congresistas.length === 0){
                getCongresistasPublic().then((v) => {
                    if (v.data.successed) {
                        setCongresistas(v.data.content);
                    };
                });
            }

            if(gruposBancada.length === 0){
                getGruposBancadaPublic().then((v) => {
                    if (v.data.successed) {
                        setGruposBancada(v.data.content);
                    };
                });
            }
            
            // Obtener LogDelegate With Seat Number de Conferencia Activa
            getLogDelegatesSeatNumberActiveConferencePublic().then((v) => {
                if (v.data.successed) {
                    setLogDelegatesSeatNumber(v.data.content);
                    setcongresistasConectados(logDelegatesSeatNumber.length);
                };
            });

            // Obtener Votos Votacion Activa Magistrados
            getVotosVotacionActivaPublic().then((v) => {
                if (v.data.successed) {
                    const votes = v.data.content;
                    //const seatNumbers = Array.from(new Set(votes.map((item: any) => item.seatnumber)))
                    //setSeatNumbers(seatNumbers);
                    const SVDelegatesVotaron = Array.from(new Set(votes.map((item: any) => item.user_id)))
                    setSVDelegatesVotaron(SVDelegatesVotaron);
                };
            });

            // Obtener Coordenadas Complete
            getSeatCoordinateCompletePublic().then((v) => {
                if (v.data.successed) {
                    setCoordenadas(v.data.content);
                };
            });
        }, 2000);
        return () => {clearInterval(inv)}
    }, [congresistas, gruposBancada, logDelegatesSeatNumber, coordenadas, SVDelegatesVotaron, congresistasConectados]);

    return (
        <div className={`container-fluid ${stylesVotaciones.diagramaCompletoBackgroundTransparente}`}>
            {coordenadas.map((coor: any, index) => {
                const logDelegate = logDelegatesSeatNumber.filter((ld:any) => { return ld.SeatNumber === coor.SeatNumber });
                const congresista = logDelegate.length ? congresistas.filter((c:any) => { return c.delegate_id === logDelegate[0].delegate_id}) : [];

                const longerName = congresista.length ? Math.max(congresista[0].FirstName.split(" ")[0].length, congresista[0].LastName.split(" ")[0].length) : 0;
                let caracteresExtras = longerName - 8;
                if(longerName === 8){
                    caracteresExtras = 1;
                }
                const fonSizePercent = caracteresExtras > 0 ? 0.00625 - (caracteresExtras * 0.00052) : 0.00625;

                const congresistaName = congresista.length ? `${congresista[0].FirstName.split(" ")[0]} ${congresista[0].LastName.split(" ")[0]}`.toUpperCase() : ""; //coor.SeatNumber;

                const bancada = congresista.length ? gruposBancada.filter((b:any) => { return b.group_name === congresista[0].bancada.toUpperCase().trim() }) : [];

                const groupColor1 = bancada.length ?  bancada[0].group_color1 : '#9a9a9a';
                const groupColor2 = bancada.length ?  bancada[0].group_color2 : '#9a9a9a';

                return (
                    <div key={coor.SeatNumber}>
                        <VotacionElementCompleto backgroundTransparente={"#ffffff"} colorFontTransparente={"#000000"} top={coor.YCoordinate} left={coor.XCoordinate} id={coor.SeatNumber} congresistaName={congresistaName} fonSizePercent={fonSizePercent} groupColor1={groupColor1} groupColor2={groupColor2}/>
                    </div>
                )
            })}
            <div style={{ position: "absolute", top: "4vh", right:"3vw", color: "#000000", fontSize: "1.2vw"}}><span>CONGRESISTAS CONECTADOS: {congresistasConectados}</span></div> 
        </div>
    )
};
export default DiagramaCompletoImpresion;